module.exports = __webpack_public_path__ + "img/service.68da3345.svg";